/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Functions from store
import {
  createDynamicColumn,
  downloadPicklistTrackingReport,
  getDateRange,
  getDynamicColumn,
  getItemMaster,
  getPicklistTrackingReport,
  getSubModulesByRoleId,
} from "../../../store";

import { CSVLink } from "react-csv";

// config file

import Config from "../../../config/index";

// Cookies
import {
  Alert,
  Backdrop,
  CircularProgress,
  Collapse,
  IconButton,
  Modal,
} from "@mui/material";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import { addDays, addMinutes, format, subDays } from "date-fns";

import MDCard from "components/MDCard";
import TextError from "utils/TextError";

import CloseIcon from "@mui/icons-material/Close";
import ViewButton from "components/standardized-components/ViewButton";
import DatePicker from "react-datepicker";

const cookies = new Cookies();
const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, sm: 400, md: 520 },
  maxHeight: "90vh",
  // Remove or adjust overflowY
  // overflowY: "visible",
  boxShadow: 24,
  p: 2,
  bgcolor: "background.paper",
  borderRadius: 3,
  zIndex: 1400,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};
const styleForCategoryModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 380, sm: 480, md: 800, lg: 1200, xl: 1200 },
  height: "fit-content",
  maxHeight: { xs: 340, sm: 340, md: 440, lg: 600, xl: 600 },
  overflow: "scroll",
  color: "black",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const PicklistTrackingReport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getItemMaster,
  getPicklistTrackingReport,
  downloadPicklistTrackingReport,
  downloadPicklistTrackingReportReducer,
  itemMaster,

  getPicklistTrackingReportReducer,
  getDateRange,
  getDateRangeReducer,
  getDynamicColumnReducer,

  createDynamicColumn,
  getDynamicColumn,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;
  const [selectedFgType, setSelectedFgType] = useState("");
  const [selectedItemCode, setSelectedItemCode] = useState("");

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getItemMaster(jwtToken);
  }, []);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let picklistReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "45716e24-cd73-4680-b525-9db71fa5ae2d",
  );

  let viewPicklist = picklistReportModule
    ? picklistReportModule.actionId.includes(
        "c092da55-b8c1-480f-9cfd-af0af5316e06",
      )
    : null;

  let viewSuids = true;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // let isoStartDate;
  // let isoEndDate;
  // useEffect(() => {
  //   if (startDate || endDate) {
  //     isoStartDate = new Date(
  //       (startDate ? startDate : new Date()).getTime() -
  //         (startDate ? startDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formatDate = (date) => {
  //       const day = String(date.getDate()).padStart(2, "0");
  //       const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
  //       const year = date.getFullYear();
  //       return `${day}-${month}-${year}`;
  //     };

  //     const formattedStartDate = formatDate(new Date(isoStartDate));

  //     isoEndDate = new Date(
  //       (endDate ? endDate : new Date()).getTime() -
  //         (endDate ? endDate : new Date()).getTimezoneOffset() * 60000
  //     ).toISOString();

  //     const formattedEndDate = formatDate(new Date(isoEndDate));
  //   }
  //   // Now you can use both formattedStartDate and formattedEndDate
  //   getMinMaxFailure(
  //     isoStartDate ? isoStartDate : "",
  //     isoEndDate ? isoEndDate : "",
  //     selectedItemCode?.value ? selectedItemCode?.value : "",
  //     jwtToken
  //   );
  // }, [startDate, endDate, selectedItemCode]);

  // {(picklist.status === 0 && `Created`) ||
  //   (picklist.status === 1 && `Released`) ||
  //   (picklist.status === 2 && `Open(Picking)`) ||
  //   (picklist.status === 3 && `Open(Picked)`) ||
  //   (picklist.status === 4 && `Open(Delivering)`) ||
  //   (picklist.status === 5 && `Delivered`)}

  const statusOptions = [
    {
      label: "All status",
      value: "",
    },
    {
      label: "Created",
      value: 0,
    },
    {
      label: "Released",
      value: 1,
    },
    {
      label: "Open(Picking)",
      value: 2,
    },
    {
      label: "Open(Picked)",
      value: 3,
    },
    {
      label: "Open(Delivering)",
      value: 4,
    },
    {
      label: "Delivered",
      value: 5,
    },
  ];

  const [state, setState] = useState({
    columns: [
      { Header: "Pick List Code", accessor: "picklistCode", width: 320 },

      { Header: "Document No", accessor: "documentNumber" },
      { Header: "Document Code", accessor: "documentCode" },

      { Header: "Item Code", accessor: "itemCode", align: "left" },
      {
        Header: "Item Description",
        accessor: "itemDescription",
        align: "left",
        width: 320,
      },
      { Header: "Item Qty", accessor: "qty" },
      { Header: "Uom", accessor: "uom" },
      { Header: "From Loc", accessor: "source", width: 320 },
      { Header: "To Loc", accessor: "destination", width: 320 },
      {
        Header: "Status",
        accessor: "status",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      // {
      //   Header: "Remarks 1",
      //   accessor: "remarks1",
      // },
      // {
      //   Header: "Remarks 2",
      //   accessor: "remarks2",
      // },
      // {
      //   Header: "Remarks 3",
      //   accessor: "remarks3",
      // },
      // {
      //   Header: "Remarks 4",
      //   accessor: "remarks4",
      // },
      {
        Header: "Created Date",

        accessor: "cd",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Picklist Delivery Date",

        accessor: "ud",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
      {
        Header: "Suid",
        accessor: "suid",
        // searchType: "select",
        // selectOptions: SuidOptions,
        // placeholder: "All Suid",

        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;
  const [openCategoryLineItemsModal, setOpenCategoryLineItemsModal] =
    useState(false);

  const handleOpenCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(true);
  };

  const handleCloseCategoryLineItemsModal = () => {
    setOpenCategoryLineItemsModal(false);
  };

  const [categoryItems, setCategoryItems] = useState("");

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getPicklistTrackingReportReducer.trnReport.data
      ? getPicklistTrackingReportReducer.trnReport.data
      : [];
    setPaginationObj(getPicklistTrackingReportReducer?.trnReport?.pagination);
    setLoading(getPicklistTrackingReportReducer.loading);

    data.map((picklist) => {
      const formatDate = new Date(picklist.cd);
      const formatDate2 = new Date(picklist.ud);
      let itemDescription = picklist.itemDescription;
      let len = desLength;

      const purchaseObject = {
        privateKey: picklist.picklistCode,
        picklistId: picklist.picklistId,
        documentCode: picklist.documentCode,
        documentNumber: picklist.documentNumber,
        picklistCode: picklist.picklistCode,
        itemId: picklist.itemId,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        picklistDate: format(
          addMinutes(formatDate2, formatDate2.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        suid: (
          <Tooltip title="View Suids">
            {viewSuids && (
              <ViewButton
                // disabled={to.suids.length == 0}
                variant="gradient"
                color="info"
                iconOnly
                type="button"
                style={{ marginRight: "-1px", borderRadius: "5px" }}
                size="small"
                onClick={() => {
                  handleOpenCategoryLineItemsModal(picklist);
                  setCategoryItems(picklist.suids);
                }}
              >
                <Icon>visibility_icon</Icon>
              </ViewButton>
            )}
          </Tooltip>
        ),

        cd: picklist.cd,
        ud: picklist.ud,
        itemCodeDes: `${picklist.itemCode} / ${
          itemDescription ? itemDescription.substring(0, len) : ""
        }`,
        itemCode: picklist.itemCode,
        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {picklist?.itemDescription?.length > 35 ? (
              <Tooltip
                title={picklist.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {picklist.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {picklist.itemDescription}
              </MDTypography>
            )}
            {picklist?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        qty: `${picklist.qty}`,
        uom: `${picklist.uom ? picklist.uom : ""}`,

        source: picklist.source,
        destination: picklist.destination,
        status: picklist.status,
        remarks1: picklist.remarks1,
        remarks2: picklist.remarks2,
        remarks3: picklist.remarks3,
        remarks4: picklist.remarks4,
        status: (
          <button
            className={
              (picklist.status === 0 && `status-created`) ||
              (picklist.status === 1 && `status-warning`) ||
              (picklist.status === 2 && `status-info`) ||
              (picklist.status === 3 && `status-info`) ||
              (picklist.status === 4 && `status-info`) ||
              (picklist.status === 5 && `status-success`)
            }
            style={{ width: "7.5rem" }}
          >
            {(picklist.status === 0 && `Created`) ||
              (picklist.status === 1 && `Released`) ||
              (picklist.status === 2 && `Open(Picking)`) ||
              (picklist.status === 3 && `Open(Picked)`) ||
              (picklist.status === 4 && `Open(Delivering)`) ||
              (picklist.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (picklist.status === 0 && `Created`) ||
          (picklist.status === 1 && `Released`) ||
          (picklist.status === 2 && `Open(Picking)`) ||
          (picklist.status === 3 && `Open(Picked)`) ||
          (picklist.status === 4 && `Open(Delivering)`) ||
          (picklist.status === 5 && `Delivered`),
      };
      tempFinishedGoods.push(purchaseObject);
    });
    setState({ ...state, rows: tempFinishedGoods });
  }, [getPicklistTrackingReportReducer]);

  const [categoryItemTable, setCategoryItemTable] = useState({
    columns: [
      { Header: "Suid", accessor: "suid", align: "left" },
      { Header: "Serial No", accessor: "serialNumber" },
      { Header: "LOT No", accessor: "lotNumber" },
      { Header: "Location Code", accessor: "locationCode" },
      { Header: "Qty", accessor: "qty", align: "left" },
      // { Header: "Created Date", accessor: "createdDate", align: "left" },
      {
        Header: "Delivered Date",

        accessor: "ud",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });

  const { columns: categoryColumns, rows: categoryRows } = categoryItemTable;

  useEffect(() => {
    let tempCategoryItemsObj = [];

    let data = categoryItems ? categoryItems : [];
    data.map((data) => {
      const formatDate = new Date(data.ud);
      const categoryItemsObj = {
        suid: data.suid,
        locationCode: data.locationCode,
        qty: data.qty,
        lotSerialNo: `${data.lotNumber ? data.lotNumber : "NA"} / ${
          data.serialNumber ? data.serialNumber : "NA"
        }`,
        lotNumber: `${data.lotNumber ? data.lotNumber : "NA"}`,
        serialNumber: `${data.serialNumber ? data.serialNumber : "NA"}`,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        ud: data.ud,
      };

      tempCategoryItemsObj.push(categoryItemsObj);
    });

    setCategoryItemTable({ ...categoryItemTable, rows: tempCategoryItemsObj });
  }, [categoryItems]);

  // const [dateRangeOptions, setDateRangeOptions] = useState([]);

  // useEffect(() => {
  //   let tempItemCodeOptions = [];
  //   let data = getDateRangeReducer.dateRange.data
  //     ? getDateRangeReducer.dateRange.data
  //     : [];

  //   data.map((item) => {
  //     tempItemCodeOptions.push({
  //       label: item.value,
  //       value: item.value,
  //     });
  //   });
  //   setDateRangeOptions(tempItemCodeOptions);
  // }, [getDateRangeReducer]);

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };
  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemCode,
        uom: item.uom,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const handleFgTypeChange = (selectedOption) => {
    setSelectedFgType(selectedOption);
    setSelectedItemCode("");
  };

  const [downloadData, setDownloadData] = useState([]);

  useEffect(() => {
    if (downloadPicklistTrackingReportReducer.loading) {
      // while loading, clear old data
      setDownloadData([]);
      return;
    }

    if (
      !downloadPicklistTrackingReportReducer.loading &&
      downloadPicklistTrackingReportReducer.consumptionReport?.data
    ) {
      let tempFinishedGoods = [];
      let data =
        downloadPicklistTrackingReportReducer.consumptionReport.data || [];
      data.map((picklist) => {
        const formatDate = new Date(picklist.cd);
        const formatDate2 = new Date(picklist.ud);
        const formatDate3 = new Date(picklist.suidCd);
        let itemDescription = picklist.itemDescription;
        let len = desLength;

        const purchaseObject = {
          privateKey: picklist.picklistCode,
          picklistId: picklist.picklistId,
          documentCode: picklist.documentCode,
          documentNumber: picklist.documentNumber,
          picklistCode: picklist.picklistCode,
          itemId: picklist.itemId,
          createdDate: format(
            addMinutes(formatDate, formatDate.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa",
          ),
          picklistDate: format(
            addMinutes(formatDate2, formatDate2.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa",
          ),
          suidDates: format(
            addMinutes(formatDate3, formatDate3.getTimezoneOffset()),
            "dd/MM/yyyy hh:mm aaa",
          ),
          cd: picklist.cd,
          itemCodeDes: `${picklist.itemCode} / ${
            itemDescription ? itemDescription.substring(0, len) : ""
          }`,
          itemCode: picklist.itemCode,
          itemDescription: picklist.itemDescription,
          qty: `${picklist.qty}`,
          uom: `${picklist.uom || ""}`,
          source: picklist.source,
          destination: picklist.destination,
          remarks1: picklist.remarks1,
          remarks2: picklist.remarks2,
          remarks3: picklist.remarks3,
          remarks4: picklist.remarks4,
          suids: picklist.suid,
          serialNumbers: picklist.serialNumber,
          suidQty: picklist.suidQty,
          lotNumbers: picklist.lotNumber,
          locationCode: picklist.locationCode,

          // serialNumbers: picklist.suids?.map((s) => s.serialNumber) || [],
          // lotNumbers: picklist.suids?.map((s) => s.lotNumber) || [],
          // locationCode: picklist.suids?.map((s) => s.locationCode) || [],
          // suidQty: picklist.suids?.map((s) => s.qty) || [],
          status: (
            <button
              className={
                (picklist.status === 0 && `status-created`) ||
                (picklist.status === 1 && `status-warning`) ||
                (picklist.status === 2 && `status-info`) ||
                (picklist.status === 3 && `status-info`) ||
                (picklist.status === 4 && `status-info`) ||
                (picklist.status === 5 && `status-success`)
              }
              style={{ width: "5.5rem" }}
            >
              {(picklist.status === 0 && `Created`) ||
                (picklist.status === 1 && `Released`) ||
                (picklist.status === 2 && `Open`) ||
                (picklist.status === 3 && `Open`) ||
                (picklist.status === 4 && `Open`) ||
                (picklist.status === 5 && `Delivered`)}
            </button>
          ),
          status2:
            (picklist.status === 0 && `Created`) ||
            (picklist.status === 1 && `Released`) ||
            (picklist.status === 2 && `Open(Picking)`) ||
            (picklist.status === 3 && `Open(Picked)`) ||
            (picklist.status === 4 && `Open(Delivering)`) ||
            (picklist.status === 5 && `Delivered`),
        };
        tempFinishedGoods.push(purchaseObject);
      });

      setDownloadData(tempFinishedGoods);
    }
  }, [downloadPicklistTrackingReportReducer]);

  const [selectedDateRange, setSelectedDateRange] = useState("");
  const [customDate, setCustomDate] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);

  const sevenDays = subDays(new Date(), 7).toISOString();
  const thirtyDays = subDays(new Date(), 30).toISOString();
  const ninetyDays = subDays(new Date(), 90).toISOString();

  const [startDate, endDate] = dateRange;

  // Fetch initial data (e.g., dropdowns)
  useEffect(() => {
    getDateRange(jwtToken);
  }, []);

  // Update `customDate` when a predefined range is selected
  useEffect(() => {
    if (selectedDateRange?.value === 7) {
      setCustomDate(sevenDays);
      setDateRange([subDays(new Date(), 7), new Date()]);
    }
    if (selectedDateRange?.value === 30) {
      setCustomDate(thirtyDays);
      setDateRange([subDays(new Date(), 30), new Date()]);
    }
    if (selectedDateRange?.value === 90) {
      setCustomDate(ninetyDays);
      setDateRange([subDays(new Date(), 90), new Date()]);
    }
  }, [selectedDateRange]);

  // Trigger download ONLY if both dates are available
  useEffect(() => {
    if (startDate !== null && endDate !== null) {
      // clear stale data first
      setDownloadData([]);
      downloadPicklistTrackingReport(
        addDays(endDate, 1).toISOString(),
        addDays(startDate, 1).toISOString(),

        searchObject,
        jwtToken,
      );
    }
  }, [startDate, endDate, pageNo, rowsPerPage, searchObject, jwtToken]);

  useEffect(() => {
    getPicklistTrackingReport(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };
  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];
  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);

    setDownloadData("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
  };

  const headers = [
    {
      label: "Pick List Code",
      key: "picklistCode",
    },
    {
      label: "Document Number",
      key: "documentNumber",
    },
    {
      label: "Document Code",
      key: "documentCode",
    },
    { label: "Item Code", key: "itemCode" },
    { label: "Item Description", key: "itemDescription" },
    { label: "Item Qty", key: "qty" },
    { label: "Uom", key: "uom" },
    { label: "From Loc", key: "source" },
    { label: "To Loc", key: "destination" },
    { label: "Status", key: "status2" },
    { label: "Created Date", key: "createdDate" },
    { label: "Picklist Delivery Date", key: "picklistDate" },
    { label: "suid", key: "suids" },
    { label: "serialNumber", key: "serialNumbers" },
    { label: "lotNumber", key: "lotNumbers" },
    { label: "locationCode", key: "locationCode" },
    { label: "suidQty", key: "suidQty" },
    { label: "suid Date", key: "suidDates" },
  ];
  const csvLink = {
    filename: "Picklist Report.csv",
    headers: headers,
    data: downloadData,
  };
  const subModuleId = "45716e24-cd73-4680-b525-9db71fa5ae2d";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getPicklistTrackingReport(pageNo, rowsPerPage, searchObject, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                <DownloadDataButton
                  style={{ marginLeft: "5px", borderRadius: "5px" }}
                  size="small"
                  type="button"
                  variant="outlined"
                  color="success"
                  iconOnly
                  tooltip="Download All Data"
                  onClick={handleCreateCircularModal}
                >
                  <Icon>download</Icon>
                </DownloadDataButton>
              </MDBox>

              <MDBox pt={3}>
                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 10,
                      entries: [15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
              </MDBox>

              <Modal
                open={openCategoryLineItemsModal}
                onClose={handleCloseCategoryLineItemsModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={styleForCategoryModal}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Suids
                    </MDTypography>
                    <MDBox>
                      <span>
                        <Tooltip title="Close">
                          <IconButton
                            style={{
                              background: "whitesmoke",
                              color: "black",
                              borderRadius: 5,
                              marginLeft: "-55px",
                              marginBottom: "5px",
                            }}
                            aria-label="close"
                            color="inherit"
                            onClick={handleCloseCategoryLineItemsModal}
                          >
                            <CloseIcon />
                          </IconButton>
                        </Tooltip>
                      </span>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginBottom: "1rem" }} />

                  <MDBox>
                    <DataTable
                      table={{ columns: categoryColumns, rows: categoryRows }}
                      isSorted={true}
                      tableSearch={true}
                      entriesPerPage={{
                        defaultValue: 5,
                        entries: [5, 10, 15, 20, 25, 30],
                      }}
                      showTotalEntries={true}
                      noEndBorder
                    />
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={createCircularModal}
                onClose={handleCreateCloseCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Download Report
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCloseCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                    <MDBox style={{ marginRight: "5px", marginBottom: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Date Range
                      </MDTypography>
                      <Select
                        // isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={dateRangeOptions}
                        value={selectedDateRange}
                        onChange={handleDateRangeChange}
                      />
                    </MDBox>
                    {selectedDateRange?.value === "Custom date Range" && (
                      <MDBox
                        // width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6">
                          Custom Date Range
                        </MDTypography>

                        <DatePicker
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date range"
                          onChange={(date) => setDateRange(date)}
                          isClearable={true}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange={true}
                          popperPlacement="right-end"

                          // withPortal
                        />

                        {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                      </MDBox>
                    )}
                    {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}

                    <MDBox mt={3}>
                      {((selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] !== null) ||
                        selectedDateRange) &&
                        downloadData.length < 1 && (
                          <TextError msg="No data found" />
                        )}
                      {(selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] === null) ||
                      downloadData.length < 1 ||
                      !selectedDateRange ? (
                        <MDButton
                          color="success"
                          fullWidth
                          type="button"
                          disabled
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <CSVLink
                          {...csvLink}
                          onClick={() => {
                            // Close modal after 2 seconds
                            setTimeout(() => {
                              handleCreateCloseCircularModal();
                            }, 1000); // 2000ms = 2 seconds
                          }}
                        >
                          <MDButton color="success" fullWidth type="button">
                            Submit
                          </MDButton>
                        </CSVLink>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* </MDBox> */}
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    itemMaster: state.itemMaster,
    getPicklistTrackingReportReducer: state.getPicklistTrackingReportReducer,
    downloadPicklistTrackingReportReducer:
      state.downloadPicklistTrackingReportReducer,
    getDateRangeReducer: state.getDateRangeReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getPicklistTrackingReport: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(
        getPicklistTrackingReport(pageNo, rowsPerPage, searchObject, jwtToken),
      ),
    downloadPicklistTrackingReport: (
      startDate,
      endDate,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        downloadPicklistTrackingReport(
          startDate,
          endDate,
          searchObject,
          jwtToken,
        ),
      ),
    getDateRange: (jwtToken) => dispatch(getDateRange(jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(
  mapStateToProps,
  mapStateToDispatch,
)(PicklistTrackingReport);
